import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { TEuMonthlyExchangeRateRow } from './types';

export const tableStructure: TTableStructure<keyof TEuMonthlyExchangeRateRow>[] = [
	{
		name: 'Year',
		selector: 'year',
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Month',
		selector: 'month',
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		// The year-month picker leaves `YYYY-MM` in the url — the component turns that into the `year`
		// and `month` filters the endpoint knows.
		name: 'Date',
		selector: 'period',
		show: true,
		sortable: false,
		filterable: false,
		separateFilter: true,
		colSpan: 1,
		type: ETableStructureType.DATE_MONTH,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Currency',
		selector: 'currency',
		show: true,
		sortable: true,
		filterable: false,
		separateFilter: true,
		separateFilterAutocomplete: true,
		colSpan: 1,
		type: ETableStructureType.CURRENCY,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'To EUR Rate',
		selector: 'toEurRate',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
	},
];
